import React, { Component } from 'react'
import './App.css'
import { Route } from 'react-router-dom'
import CreditRequests from './pages/credit_requests'
import CreateCreditRequest from './pages/create_credit_request'
import {
  Button,
  AppBar,
  IconButton,
  Typography,
  Toolbar
} from '@material-ui/core'
import MenuIcon from '@material-ui/icons/Menu'
import SignIn from './pages/signin'
import CreditRequestProcessing from './pages/credit_request_processing'
import CreditRequestDecision from './pages/credit_request_decision'
import axios from 'axios'
import { AUTH_API_URL } from './lib/env'
import * as queryString from 'query-string'
import './sass/main.sass'
import withSeo from './container/SeoProvider/withSeo'
import Home from './pages/home'
import CalcPrint from './pages/print'
import ErrorModal from './asterX-UIkit/modals/ErrorModal'
import SalesListAmp from './pages/sales_list_amp'
import SalesListOpa from './pages/sales_list_opa'

class App extends Component {
  constructor(props) {
    super(props)

    const values = queryString.parse(this.props.location.search)
    if (values.token) {
      localStorage.setItem('token', values.token)
    }

    this.state = {
      token: localStorage.getItem('token'),
      appBarVisible: true,
      error: false
    }
  }

  signOut() {
    localStorage.clear()
    this.props.history.push('/signin')
  }

  componentDidMount() {
    const self = this
    const values = queryString.parse(this.props.location.search)
    if (values.token) {
      localStorage.setItem('token', values.token)
      this.setState({ token: values.token, appBarVisible: false })
      this.checkUserRoleAndRedirect(values.token)
    } else {
      if (localStorage.getItem('token')) {
        this.setState({ token: localStorage.getItem('token') })
        this.checkUserRoleAndRedirect(localStorage.getItem('token'))
      } else {
        this.props.history.push('/signin')
      }
    }

    axios.interceptors.response.use(
      response => response,
      error => {
        if (!error.message.includes('401') && !error.message.includes('403')) {
          self.setState({
            error: error
          })
        }

        return Promise.reject(error)
      }
    )
  }

  checkUserRoleAndRedirect(token) {
    let self = this
    const { seo } = this.props
    axios
      .get(AUTH_API_URL + '/users/getUserByToken', {
        headers: {
          Authorization: `Bearer ${token}`
        }
      })
      .then(function (response) {
        let roles = response.data.roles

        let accessGranted = false
        for (let role of roles) {
          if (role.code === 'MANAGER_NEWCAR') {
            accessGranted = true
            self.props.history.push('/credit_request_processing')
          } else if (
            role.code === 'MANAGER_ASTER' ||
            role.code === 'ADMIN' ||
            role.code === 'HEAD_FS' ||
            role.code === 'MANAGER_AMP_NEWCAR'
          ) {
            accessGranted = true
            self.props.history.push('/')
            seo.registerSeo()
          }
        }

        console.log(response.data.roles)
        if (!accessGranted) {
          self.props.history.push('/signin')
        }
      })
      .catch(function (error) {
        if (error.message.includes('401') || error.message.includes('403')) {
          self.props.history.push('/signin')
        }
      })
  }

  render() {
    return (
      <div style={{ flexGrow: '1' }}>
        {this.state.appBarVisible && (
          <AppBar
            position="static"
            className="no-print"
            style={{
              backgroundColor: '#333'
            }}
          >
            <Toolbar>
              <IconButton edge="start" color="inherit" aria-label="menu">
                <MenuIcon />
              </IconButton>
              <Typography variant="h6" style={{ flexGrow: '1' }}>
                Aster CarFin
              </Typography>
              <Button color="inherit" onClick={this.signOut.bind(this)}>
                Выход
              </Button>
            </Toolbar>
          </AppBar>
        )}
        <div style={{ padding: '10px' }} className="mainPaper">
          <Route exact path="/credit_requests" component={CreditRequests} />
          <Route
            exact
            path="/signin"
            component={props => <SignIn {...props} />}
          />
          <Route
            exact
            path="/create_credit_request"
            component={CreateCreditRequest}
          />
          <Route
            exact
            path="/credit_request_processing"
            component={CreditRequestProcessing}
          />
          <Route
            exact
            path="/credit_request_decision/:id"
            component={CreditRequestDecision}
          />
          <Route exact path="/sale/:id" component={Home} />
          <Route exact path="/" component={Home} />

          <Route exact path="/sales_list_amp" component={SalesListAmp} />
          <Route exact path="/sales_list_opa" component={SalesListOpa} />
          <Route
            exact
            path="/calc_print"
            component={props => <CalcPrint {...props} />}
          />
        </div>
        {!!this.state.error && (
          <ErrorModal
            e={this.state.error}
            close={() => this.setState({ error: false })}
            snackbar={false}
          />
        )}
      </div>
    )
  }
}

export default withSeo(App)
